import { useEffect, useState, useCallback } from "react";
import api from "../api";

// Conteggio delle richieste in attesa di approvazione (ferie/trasferte/smart working/straordinari).
// Attivo solo per responsabili/admin. Si aggiorna senza refresh dell'app:
//  - polling ravvicinato (15s)
//  - al ritorno di focus/visibilità della scheda del browser
//  - immediatamente all'evento globale "tb-approvals-changed" (es. dopo approva/rifiuta).
const POLL_MS = 15000;

export function usePendingApprovals(enabled) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(() => {
    if (!enabled) { setCount(0); return; }
    api.get("/approvals/pending-count").then((r) => setCount(r.data?.total || 0)).catch(() => {});
  }, [enabled]);

  useEffect(() => {
    refresh();
    if (!enabled) return undefined;
    const id = setInterval(refresh, POLL_MS);
    const onVisible = () => { if (document.visibilityState === "visible") refresh(); };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", refresh);
    window.addEventListener("tb-approvals-changed", refresh);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", refresh);
      window.removeEventListener("tb-approvals-changed", refresh);
    };
  }, [enabled, refresh]);

  return { count, refresh };
}

// Da chiamare dopo un'azione che cambia il numero di richieste in attesa
// (approva/rifiuta/revoca) per aggiornare subito il badge, senza ricaricare la pagina.
export function notifyApprovalsChanged() {
  window.dispatchEvent(new Event("tb-approvals-changed"));
}
